import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./components/pages/home";
import About from "./components/pages/about";
import Client from "./components/pages/clients";
import Service from "./components/pages/service";
import Contact from "./components/pages/contact";
import './index.css'
import WhatsAppButton from "./components/pages/whatsapp";
import Chatbot from "./components/pages/chatbot";
function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Service />
      <Client />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Chatbot />
    </div>
  );
}

export default App;












